import httpClient from "@/api/httpClient";
import PlacePage from "@/model/PlacePage";

function listPlaces(): Promise<PlacePage> {
  return httpClient.getJson<PlacePage>("/api/places?page=0&size=100");
}

const placesApi = {
  listPlaces,
};

export default placesApi;
